const SliderContent = () => (
  <div
    className="position-relative h-100 d-flex justify-content-center align-items-center"
    style={{
      backgroundImage: "url('assets/images/originals/citynights.jpg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      position: "relative",
    }}
  >
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    ></div>

    <div
      className="slider-content"
      style={{
        zIndex: 1,
        color: "#fff",
        textAlign: "center",
        padding: "20px",
        maxWidth: "600px",
      }}
    >
      <h3 style={{ fontSize: "2rem", marginBottom: "10px" }}>
        Scalable, Modular, Consistent
      </h3>
      <p style={{ fontSize: "1.2rem" }}>
        Easily exclude the components you don't require. Lightweight, consistent
        Bootstrap-based styles across all elements and components.
      </p>
    </div>
  </div>
);

export default SliderContent;
